(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('[data-hs-menu-toggle]');
    var closeBtn = document.querySelector('[data-hs-menu-close]');
    var menu = document.querySelector('[data-hs-mobile-menu]');
    if (!toggle || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('hs-menu-open');
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hs-menu-open');
    }

    toggle.addEventListener('click', function () {
      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    menu.querySelectorAll('[data-hs-menu-link]').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 780 && menu.classList.contains('is-open')) closeMenu();
    });
  });
})();
